import { odinClient } from "@/config/client"

export type QuestionType = "open_ended" | "multiple_choice" | "analysis"

export interface Feedback {
  approvalScore: number
  scorePercentage: number
  bullets: string[] | null
  positive: string
  negative: string
}

export interface Review {
  correctAnswerIndex: number
  review: string
  score: number
}

export interface NextQuestionDiagnosticsMultipleChoise {
  index: number
  question: string
  questionType: "multiple_choice"
  options: string[]
  answer: string
}

export interface NextQuestionDiagnosticsOpenEnded {
  index: number
  question: string
  questionType: "open_ended"
  options: null
  answer: string
}

export interface NextQuestionDiagnosticAnalysis {
  index: number
  question: string
  questionType: "analysis"
  options: null
  answer: string
}

export type NextQuestionDiagnostics =
  | NextQuestionDiagnosticsMultipleChoise
  | NextQuestionDiagnosticsOpenEnded
  | NextQuestionDiagnosticAnalysis

export interface DiagnosticActivity {
  id: string
  feedback: Feedback
  review: Review
  next: NextQuestionDiagnostics
  more: boolean
  total: number
  current: number
}

export interface UpdateDiagnosticStudySessionResponse {
  description: DiagnosticActivity
}

interface UpdateStudySessionData {
  answer?: string
  answerIndex?: number
  elapsedTimeInSeconds?: number
}

export function update(sessionId: string, activityId: string, data: UpdateStudySessionData) {
  return odinClient.put<UpdateDiagnosticStudySessionResponse, UpdateStudySessionData>(
    `/v1/activities/${activityId}/diagnostics/study-session/${sessionId}`,
    data,
  )
}
